<h3 mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
  {{data.message}}
</div>
<div style="float:right;margin:20px;">
  <button mat-button class="primary-color-icon" style="margin:0px 10px;" [mat-dialog-close]="true">{{confirmButtonName}}</button>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
</div>